import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type relate*/
export var operators = [
    OperatorsDef[Operators.OPERATOR_EQUAL],
    OperatorsDef[Operators.OPERATOR_IS_NULL],
    OperatorsDef[Operators.OPERATOR_NOT_NULL],
];
